import React from 'react'
import { getAllAttributeIds } from '../../Utility/TreeUtility';
import { SIZE_SMALL, Toggle } from "@mds/mds-reactjs-library"

const SelectionLinks = ({ dimension, selection, setSelection, showDefinition, setShowDefinition }) => {

  let singleSelect = dimension?.Details ? JSON.parse(dimension?.Details)?.singleSelect : false;

  const allIds = dimension ? getAllAttributeIds(dimension) : [];
  const selectedIds = selection?.Attributes ?? [];
  const isAllSelected = allIds.length > 0 && allIds.length === selectedIds.length && allIds.every((id) => selectedIds.includes(id));
  const isNoneSelected = selectedIds.length === 0;

  const selectAll = () => {
    if (singleSelect)
      return;
    setSelection(dimension.DimensionID, getAllAttributeIds(dimension));
  }

  const selectNone = () => {
    if (singleSelect)
      return;
    setSelection(dimension.DimensionID, []);
  }

  const selectInvert = () => {
    if (singleSelect)
      return;
    setSelection(dimension.DimensionID, getAllAttributeIds(dimension).filter((attributeId) => selection.Attributes.indexOf(attributeId) === -1)
    );
  }

  return (
    <div className="short-filters">
      {/* <label>Select</label> */}
      <div className="flex1">
        <input className={singleSelect ? 'cursor-default' : isAllSelected ? 'active' : ''}
          type="button" value="Select all" onClick={selectAll} />
        <input className={singleSelect ? 'cursor-default' : isNoneSelected ? 'active' : ''}
          type="button" value="Clear all" onClick={selectNone} />
        {/* <input className={singleSelect ? 'cursor-default' : shortFilterSelected === 'invert' ? 'active' : ''}
          type="button" value="Invert" onClick={selectInvert} /> */}
      </div>
       <br />
      {/* <Toggle className="definitions" size={SIZE_SMALL} label="Definitions" onChange={e => setShowDefinition(e.target.checked)} /> */}
    </div>
  )
}

export default SelectionLinks
